export default {
  kind: {
    ewallet: 'E-wallet',
    crypto: 'Crypto',
    bank: 'Bank card',
    alipay: 'Alipay',
  },
  loading: 'Loading…',
  feeFree: 'Fee-free · faster arrival',
  feePct: 'Fee {n}%',
  defaultTag: 'Default',
  setDefault: 'Set as default',
  edit: 'Edit account',
  delete: 'Delete',
  add: '＋ Add {name}',
  pickTitle: 'Select withdrawal account',
  formAdd: 'Add {name}',
  formEdit: 'Edit {name}',
  currency: 'Currency',
  currencyType: 'Currency',
  network: 'Network / chain',
  channel: 'Wallet channel',
  holderName: 'Name',
  cardHolder: 'Cardholder name',
  realName: 'Full name',
  bankName: 'Bank name',
  region: 'Region',
  branch: 'Branch',
  pickRegion: 'Select region',
  pickCurrency: 'Currency',
  phCurrencySearch: 'Enter search keyword',
  address: 'Wallet address',
  cardNo: 'Bank card No.',
  bankAccount: 'Bank account No.',
  account: 'Account No.',
  phHolder: 'Enter name (matching account KYC)',
  phCardHolder: 'Enter cardholder name',
  phRealName: 'Enter your full name',
  phBankAccount: 'Enter receiving account number',
  phBranch: 'Enter branch name',
  phRegionSelect: 'Select region',
  regionCn: 'China',
  regionJp: 'Japan',
  regionTw: 'Taiwan',
  regionHk: 'Hong Kong',
  regionMo: 'Macau',
  regionSg: 'Singapore',
  phBankSelect: 'Select a bank',
  phBankSearch: 'Search banks',
  bankEmpty: 'No matching banks',
  countryEmpty: 'No matching countries/regions',
  phAlipay: 'Alipay account (phone / email)',
  phCardNo: 'Bank card number',
  phAddress: 'USDT({ch}) wallet address',
  phEwallet: '{ch} wallet account',
  hintEdit: '· Name and account info can’t be edited; delete and re-add to change',
  hintCrypto: '· Double-check the address and network; wrong-chain transfers can’t be recovered',
  hintIdentity: '· The account must match your identity to ensure arrival',
  saveEdit: 'Save changes',
  saveUse: 'Save & use',
  toastDefault: 'Set as default payout account',
  toastDeleted: 'Payout account removed',
  toastSaved: 'Changes saved',
  toastSavedUse: 'Account saved and selected',
  errAlipay: 'Alipay account must be a phone number (with country code) or email — please check',
  errBank: 'Bank card number must be 16–19 digits',
  errEwallet: '{ch} account must be 6+ letters or digits',
  errCrypto: 'USDT({ch}) address format is invalid',
  errNameMatch: 'Payout account name must match your existing account ({name})',

  fundTitle: 'Enter fund password',
  fundDesc: {
    generic: 'For your security, enter your 6-digit fund password to continue.',
    add: 'Enter your fund password to add a payout account.',
    deposit: 'Enter your fund password to confirm this deposit.',
    setDefault: 'Enter your fund password to set the default payout account.',
    edit: 'Enter your fund password to edit this payout account.',
    delete: 'Enter your fund password to delete this payout account.',
    withdraw: 'Enter your fund password to confirm this withdrawal.',
    cancelWithdraw: 'Enter your fund password to cancel this withdrawal request.',
    changeLoginPwd: 'Enter your fund password to change the login password.',
    changePhone: 'Enter your fund password to change the linked phone.',
    changeEmail: 'Enter your fund password to change the linked email.',
  },
  fundPh: '6-digit fund password',
  fundConfirm: 'Confirm',
  fundHint: '5 wrong tries locks it for 2 hours.',
  errFundFormat: 'Enter a 6-digit fund password',
  errFundFail: 'Wrong fund password',
  /** 1030 lock: remaining time from retry_after_seconds / Retry-After / locked_until */
  errFundLocked: 'Fund password wrong 5 times — locked. Try again in {wait}.',
  errFundLockedSoon: 'Fund password wrong 5 times — locked. Please try again later.',
}
